"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TripRouteSummaryCard = TripRouteSummaryCard;
exports.getPassengerTypesForDisplay = getPassengerTypesForDisplay;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactI18next = require("react-i18next");
var _passengerTypes = require("@/app-config/passengerTypes");
var _passengerCategories = require("@/constants/passengerCategories");
var _RouteDetails = require("./RouteDetails");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MAX_PASSENGER_ICONS = 3;
function formatSchedule(date, isOpenTicket, openTicketLabel) {
  if (isOpenTicket) return openTicketLabel;
  return date ? (0, _moment["default"])(date).format('D MMM h:mm A') : null;
}
function getPassengerTypesForDisplay(passengers, isFlat) {
  var passengerTypeList = passengers.map(function (passenger) {
    var category = passenger.busCategory || passenger.category || _passengerCategories.DEFAULT_PASSENGER_CATEGORY;
    return (0, _passengerTypes.getPassengerTypeByCategory)(category);
  }).filter(function (passengerType) {
    return isFlat ? passengerType.iconVariant : passengerType.icon;
  });
  return [].concat((0, _toConsumableArray2["default"])(new Set(passengerTypeList)), (0, _toConsumableArray2["default"])(passengerTypeList)).slice(0, Math.min(MAX_PASSENGER_ICONS, passengerTypeList.length));
}
function TripRouteSummaryCard(_ref) {
  var _ref$departureDate = _ref.departureDate,
    departureDate = _ref$departureDate === void 0 ? null : _ref$departureDate,
    _ref$destinationCity = _ref.destinationCity,
    destinationCity = _ref$destinationCity === void 0 ? '' : _ref$destinationCity,
    _ref$destinationTermi = _ref.destinationTerminal,
    destinationTerminal = _ref$destinationTermi === void 0 ? '' : _ref$destinationTermi,
    _ref$isFlat = _ref.isFlat,
    isFlat = _ref$isFlat === void 0 ? false : _ref$isFlat,
    _ref$isOpenTicket = _ref.isOpenTicket,
    isOpenTicket = _ref$isOpenTicket === void 0 ? false : _ref$isOpenTicket,
    _ref$isReturnOpenTick = _ref.isReturnOpenTicket,
    isReturnOpenTicket = _ref$isReturnOpenTick === void 0 ? false : _ref$isReturnOpenTick,
    _ref$isRoundTrip = _ref.isRoundTrip,
    isRoundTrip = _ref$isRoundTrip === void 0 ? false : _ref$isRoundTrip,
    onChangeSchedule = _ref.onChangeSchedule,
    onShowDetails = _ref.onShowDetails,
    _ref$originCity = _ref.originCity,
    originCity = _ref$originCity === void 0 ? '' : _ref$originCity,
    _ref$originTerminal = _ref.originTerminal,
    originTerminal = _ref$originTerminal === void 0 ? '' : _ref$originTerminal,
    _ref$passengers = _ref.passengers,
    passengers = _ref$passengers === void 0 ? [] : _ref$passengers,
    _ref$returnDate = _ref.returnDate,
    returnDate = _ref$returnDate === void 0 ? null : _ref$returnDate;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var routeContainerRef = _react["default"].useRef(null);
  var routeContentRef = _react["default"].useRef(null);
  var routeTrackRef = _react["default"].useRef(null);
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    hasRouteOverflow = _React$useState2[0],
    setHasRouteOverflow = _React$useState2[1];
  var visiblePassengerTypes = getPassengerTypesForDisplay(passengers, isFlat);
  var extraPassengerCount = passengers.length - visiblePassengerTypes.length;
  var hasDetails = Boolean(onShowDetails);
  var openTicketLabel = t('purchase:label.open_ticket');
  var schedule = formatSchedule(departureDate, isOpenTicket, openTicketLabel);
  var returnSchedule = isRoundTrip ? formatSchedule(returnDate, isReturnOpenTicket, openTicketLabel) : null;
  var scheduleGapClass = returnSchedule ? 'md:gap-1.5' : '';
  (0, _react.useEffect)(function () {
    function updateRouteOverflow() {
      var _window$matchMedia$ma, _window$matchMedia, _window;
      var routeContainer = routeContainerRef.current;
      var routeContent = routeContentRef.current;
      var routeTrack = routeTrackRef.current;
      if (!routeContainer || !routeContent || !routeTrack) return;
      var isMobile = (_window$matchMedia$ma = (_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, '(max-width: 767px)').matches) !== null && _window$matchMedia$ma !== void 0 ? _window$matchMedia$ma : true;
      var hasOverflow = isMobile && routeContent.scrollWidth > routeContainer.clientWidth;
      routeTrack.style.setProperty('--trip-route-scroll-distance', "".concat(routeContent.scrollWidth + 16, "px"));
      setHasRouteOverflow(hasOverflow);
    }
    updateRouteOverflow();
    window.addEventListener('resize', updateRouteOverflow);
    var routeContainer = routeContainerRef.current;
    var routeContent = routeContentRef.current;
    var resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateRouteOverflow);
    if (resizeObserver && routeContainer && routeContent) {
      resizeObserver.observe(routeContainer);
      resizeObserver.observe(routeContent);
    }
    return function () {
      window.removeEventListener('resize', updateRouteOverflow);
      resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
    };
  }, [destinationCity, destinationTerminal, originCity, originTerminal]);
  if (!originTerminal || !destinationTerminal) return null;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "box-border flex flex-col w-full rounded-3xl bg-white gap-y-4 p-4 font-sans shadow-[0_2px_12px_rgba(75,85,99,0.04)]",
    "aria-label": t('purchase:label.trip_detail'),
    "data-sentry-component": "TripRouteSummaryCard",
    "data-sentry-source-file": "TripRouteSummaryCard.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-y-4 flex-col-reverse md:flex-col"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex flex-wrap items-baseline gap-x-3 gap-y-1 text-sm leading-[1.2] font-semibold text-gray-500 ".concat(returnSchedule ? 'md:gap-x-1.5 md:text-xs' : ''),
    "data-testid": "trip-route-schedule"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex items-baseline gap-3 whitespace-nowrap ".concat(scheduleGapClass)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-normal text-gray-400"
  }, t('purchase:label.departure')), schedule, returnSchedule && /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "-")), returnSchedule && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex items-baseline gap-3 whitespace-nowrap ".concat(scheduleGapClass)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-normal text-gray-400"
  }, t('general:return')), returnSchedule)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full overflow-hidden motion-reduce:overflow-x-auto md:overflow-visible",
    "data-testid": "trip-route-details",
    ref: routeContainerRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-max flex-nowrap md:w-full md:flex-col ".concat(hasRouteOverflow ? 'animate-[trip-route-scroll_10s_linear_infinite] md:animate-none motion-reduce:animate-none' : ''),
    "data-testid": "trip-route-track",
    ref: routeTrackRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-none ".concat(hasRouteOverflow ? 'pr-4' : '')
  }, /*#__PURE__*/_react["default"].createElement(_RouteDetails.RouteDetails, {
    destinationCity: destinationCity,
    destinationTerminal: destinationTerminal,
    originCity: originCity,
    originTerminal: originTerminal,
    routeContentRef: routeContentRef,
    testId: "trip-route-content",
    "data-sentry-element": "RouteDetails",
    "data-sentry-source-file": "TripRouteSummaryCard.tsx"
  })), hasRouteOverflow && /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: "flex flex-none pr-4"
  }, /*#__PURE__*/_react["default"].createElement(_RouteDetails.RouteDetails, {
    destinationCity: destinationCity,
    destinationTerminal: destinationTerminal,
    originCity: originCity,
    originTerminal: originTerminal
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-y-4 ".concat(hasDetails ? 'flex-col' : 'justify-between md:flex-col')
  }, (passengers.length > 0 || hasDetails) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-h-10 items-center justify-between gap-2.5"
  }, passengers.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 items-center gap-2.5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-none items-center",
    "aria-hidden": "true"
  }, visiblePassengerTypes.map(function (passengerType, index) {
    var icon = isFlat ? passengerType.iconVariant : passengerType.icon;
    var zIndexClass = ['z-[4]', 'z-[3]', 'z-[2]'][index];
    return icon ? /*#__PURE__*/_react["default"].createElement("img", {
      alt: "",
      className: "relative -ml-[9px] size-10 flex-none rounded-full border-2 border-white bg-white object-contain p-[3px] shadow-[0_3px_10px_rgba(75,85,99,0.16)] first:ml-0 ".concat(zIndexClass)
      // Decorative, stateless slots can safely use their fixed position.
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "".concat(passengerType.label, "-").concat(index),
      src: icon
    }) : null;
  }), extraPassengerCount > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "relative z-[1] -ml-[9px] flex size-10 flex-none items-center justify-center rounded-full border-2 border-white bg-white text-2xl leading-none font-normal tracking-[-1.5px] text-gray-400 shadow-[0_3px_10px_rgba(75,85,99,0.16)] [-webkit-text-fill-color:#fff] [-webkit-text-stroke:1px_#9ca3af]"
  }, "+", extraPassengerCount)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "m-0 whitespace-nowrap text-base leading-[1.2] font-medium text-gray-600 lowercase"
  }, t('purchase:title.quick_purchase_passengers', {
    count: passengers.length
  }))), hasDetails && /*#__PURE__*/_react["default"].createElement("button", {
    className: "group ml-auto flex flex-none cursor-pointer items-center gap-2 rounded-full border-0 bg-transparent p-0 font-sans text-sm leading-[1.2] font-normal text-gray-500 transition-colors duration-200 hover:text-accent-regular focus-visible:ring-2 focus-visible:ring-accent-regular focus-visible:ring-offset-2 focus-visible:outline-none motion-reduce:transition-none",
    onClick: onShowDetails,
    type: "button"
  }, t('general:show_details_new'), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex size-8 flex-none items-center justify-center rounded-full bg-white text-gray-400 shadow-[0_3px_10px_rgba(75,85,99,0.16)] transition-colors duration-200 group-hover:text-accent-regular motion-reduce:transition-none"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    className: "size-4",
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 6L8 10L12 6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }))))), /*#__PURE__*/_react["default"].createElement("button", {
    className: "min-h-12 ".concat(hasDetails ? 'w-full' : 'md:w-full', " cursor-pointer rounded-full border border-gray-200 bg-white px-4 py-2.5 font-sans text-base font-semibold text-gray-500 shadow-[0_3px_10px_rgba(75,85,99,0.1)] transition-[border-color,box-shadow,color,transform] duration-200 hover:border-accent-regular hover:text-accent-regular hover:shadow-[0_5px_14px_rgba(75,85,99,0.14)] focus-visible:ring-2 focus-visible:ring-accent-regular focus-visible:ring-offset-2 focus-visible:outline-none active:translate-y-px motion-reduce:transition-none"),
    onClick: onChangeSchedule,
    type: "button"
  }, t('purchase:button.change_schedule'))));
}